<div id="image-full-screen-dialog">
    <div class="header">
        {{imageName}}
    </div>
    <div class="main">
        <div class="image-full" [ngStyle]="{'background-image': 'url(' + imageUrl + ')'}"></div>
    </div>
    <mat-icon class="close" (click)="close()">close</mat-icon>

</div>